import { CSSProperties, FC, useCallback, useEffect, useState } from 'react';
import { Select } from 'antd';
import { GridFilterAction } from '../../../system/hooks/useGridFilter';

interface MarketingEventsFiltersProps {
    itemOptions: Array<{ label: string; value: string | null }>;
    filterName: string;
    gridFilter: IGridFilter;
    dispatchGridFilter: (value: GridFilterAction) => void;
    disabled?: boolean;
    loading?: boolean;
    placeholder?: string;
    showClearButton?: boolean;
    style?: CSSProperties
}

const SelectAnt: FC<MarketingEventsFiltersProps> = ({
    itemOptions,
    filterName,
    gridFilter,
    dispatchGridFilter,
    disabled = false,
    loading = false,
    placeholder,
    style
}) => {
    const getCurrentColumnFilterValue = useCallback((): string | null => {
        const filter = gridFilter.columnFilters?.find(f => f.name === filterName);
        return filter ? filter.value as string : null;
    }, [gridFilter.columnFilters, filterName]);

    const [currentItem, setCurrentItem] = useState<string | null>(() => 
        getCurrentColumnFilterValue()
    );

    const hasFilter = currentItem && currentItem.trim()

    const handleColumnFilterChange = useCallback((value: string | null | undefined, filterName: string) => {
        const normalizedValue = value === undefined ? null : value;
        
        dispatchGridFilter({
            type: "deleteColumnFilter",
            payload: filterName
        });

        if (normalizedValue !== null && normalizedValue !== '') {
            
            dispatchGridFilter({
                type: "addColumnFilter",
                payload: {
                    name: filterName,
                    value: normalizedValue,
                    operator: "Eq",
                    invisible: false
                } as IGridColumnFilter
            });
        }
    }, [dispatchGridFilter]);

    const handleTypeChange = useCallback((value: string | null) => {
        setCurrentItem(value)
        handleColumnFilterChange(value, filterName);
    }, [handleColumnFilterChange]);

    const handleClearStateFilter = useCallback(() => {
        handleColumnFilterChange(null, filterName);
    }, [handleColumnFilterChange]);

    useEffect(() => {
        const newValue = getCurrentColumnFilterValue();
        if (newValue !== currentItem) {
            setCurrentItem(newValue);
        }
    }, [gridFilter, getCurrentColumnFilterValue, currentItem]);

    return (
        <Select
            showSearch
            style={style}
            className={hasFilter ? `has-selected-items` : ''}
            placeholder={placeholder}
            value={currentItem}
            onChange={handleTypeChange}
            allowClear
            disabled={disabled}
            loading={loading}
            options={itemOptions}
            onClear={handleClearStateFilter}
        />
    );
};

export { SelectAnt };